<div class="flex flex-col mt-8 mb-4">
  <h1 class="text-lg font-semibold">Claim Approvals</h1>
  <p class="text-sm text-gray-600">Choose when a manager has to approve a claim payment before it can be prepared.</p>
</div>

<div *ngIf="loading" class="text-sm text-gray-500">Loading claim approvals...</div>

<form *ngIf="!loading" class="flex flex-col gap-6 pb-10" [formGroup]="form">
  <div class="flex flex-col gap-2">
    <div class="text-sm">
      <p class="text-gray-700 font-medium">Net payable over</p>
      <p class="text-gray-600">Authorizations above this amount need a manager's approval. Leave empty for no limit.</p>
    </div>
    <input
      vsInput
      currencyMask
      type="text"
      class="w-full sm:max-w-sm"
      formControlName="netPayableOver"
      placeholder="No limit"
      [options]="currencyMaskConfig"
    />
  </div>

  <div class="flex">
    <label
      class="flex items-center gap-4 cursor-pointer"
      tooltipPosition="end"
      [vsTooltip]="!canEdit ? 'Insufficient permissions to update settings' : ''"
    >
      <input
        vsInput
        type="checkbox"
        appearance="toggle"
        formControlName="customerShare"
        (change)="form.markAsDirty()"
      />
      <div class="text-sm">
        <p class="text-gray-700 font-medium">Customer share of a split</p>
        <p class="text-gray-600">When a split pays the customer part of the money, their share needs approval.</p>
      </div>
    </label>
  </div>

  <div class="flex flex-col-reverse sm:flex-row sm:justify-end items-center gap-3" *ngIf="canEdit && form.dirty">
    <button vs-button class="sm:flex-none w-full sm:w-fit" appearance="outline" [disabled]="saving" (click)="reset()">
      Cancel
    </button>
    <button vs-button class="sm:flex-none w-full sm:w-fit" theme="primary" [disabled]="saving" (click)="save()">
      Save
    </button>
  </div>
</form>
